"use client";

import { useSessionStore } from "@/app/store/use-session-store";
import {
  PointStatus,
  useAddressStore,
} from "@/entities/address/model/use-address-store";
import { usePlatformStore } from "@/entities/platform";
import { HStack, Spinner, Text, VStack } from "@chakra-ui/react";
import { useTranslations } from "next-intl";
import { useMemo, useState } from "react";
import { FaAngleRight } from "react-icons/fa6";
import Points from "./points";

const SelectLocation = () => {
  const [openPoints, setOpenPoints] = useState(false);
  const { isPorte, params } = usePlatformStore();

  const t = useTranslations();
  const points = useAddressStore((state) => state.points);
  const openMap = useAddressStore((state) => state.openMap);
  const geolocation = useSessionStore((state) => state.geolocation);

  const activePoint = useMemo(
    () => points.find((point) => point.status === PointStatus.ACTIVE),
    [points],
  );

  const handleClick = () => {
    if (isPorte) return;

    if (points?.length > 0) {
      setOpenPoints(true);
      return;
    }
    openMap();
  };

  return (
    <>
      <VStack gap="0" alignItems="flex-start">
        <HStack gap={"6px"} color="text" onClick={handleClick}>
          <Text maxW={"262px"} lineHeight={1.2} fontWeight={600} truncate>
            {isPorte
              ? params.address
              : activePoint?.address && geolocation === "accepted"
                ? activePoint?.address
                : geolocation === "pending"
                  ? t("location.determining_location")
                  : t("add_address")}
          </Text>
          {geolocation === "pending" && !isPorte ? (
            <Spinner size="xs" ml={1} />
          ) : (
            <FaAngleRight />
          )}
        </HStack>
        <Text fontSize="sm" color="gray.600" fontWeight={300} lineHeight={1.2}>
          {t("delivery_address")}
        </Text>
      </VStack>
      <Points
        isOpen={openPoints && points?.length > 0}
        onClose={() => setOpenPoints(false)}
      />
    </>
  );
};

export default SelectLocation;
